export const generatedRoutes: Router.RouterData[] = [
  {
    children: [
      {
        children: [
          {
            component: 'home/index',
            handle: { icon: 'mdi:monitor-dashboard', title: '首页' },
            name: 'homeIndex',
            path: 'home',
            type: 'C'
          }
        ],
        component: 'base',
        handle: {
          icon: 'material-symbols-light:person',
          title: '首页'
        },
        name: 'home',
        redirect: '/home',
        type: 'M'
      },
      {
        children: [
          {
            children: [
              {
                component: '(blank)/login/index',
                handle: { constant: true, hideInMenu: true, title: '登录' },
                name: '(blank)_login_code-login',
                path: 'login',
                type: 'C'
              }
            ],
            component: 'login',
            handle: { title: '登录' },
            name: '(blank)_login',
            redirect: '(blank)/login',
            type: 'M'
          },
          {
            component: '(blank)/login-out/index',
            handle: { constant: true, hideInMenu: true, title: '退出登录' },
            name: '(blank)_login-out',
            path: 'login-out',
            type: 'C'
          }
        ],
        component: 'blank',
        handle: { constant: true, hideInMenu: true },
        name: '(blank)',
        type: 'M'
      },
      {
        component: '_builtin/403/index',
        handle: {
          constant: true,
          hideInMenu: true,
          title: '无权限'
        },
        name: '403',
        path: '403',
        type: 'C'
      },
      {
        component: '_builtin/404/index',
        handle: {
          constant: true,
          hideInMenu: true,
          title: '页面不存在'
        },
        name: '404',
        path: '/404',
        type: 'C'
      },
      {
        component: '_builtin/500/index',
        handle: {
          constant: true,
          hideInMenu: true,
          title: '服务器错误'
        },
        name: '500',
        path: '500',
        type: 'C'
      },
      {
        component: '_builtin/404/index',
        handle: {
          constant: true,
          hideInMenu: true,
          title: '页面不存在'
        },
        name: 'notFound',
        path: '*',
        type: 'C'
      }
    ],
    component: 'root',
    errorBoundary: 'default',
    fallback: 'default',
    handle: { hideInMenu: true, i18nKey: 'route.root', title: 'root' },
    name: 'root',
    path: '/',
    redirect: '/home',
    type: 'M'
  }
];
